import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs/Rx';
import { loginResult } from '../model/loginResult';
import { Response } from '@angular/http/src/static_response';
import { iRecordType } from '../model/iRecordType';
import { Clinic } from '../model/clinic';
import { Therapist } from '../model/therapist';
import { DBUser } from '../model/user';
import { iListDataResponse } from '../shared/modules/crud/model/iListDataResponse';
import { FillValue } from '../model/fillvalue';
import { observableToBeFn } from 'rxjs/testing/TestScheduler';
import { isComponentView } from '@angular/core/src/view/util';



const API_URL = environment.apiUrl;
const RES_URL = environment.resUrl;

@Injectable()
export class ApiService {

  private _token: string;
  private _refreshToken:string;

  constructor(
    private http: HttpClient
  ) { 
      
  }

  private __apath<T>(c: new(values: Object)=> T, collectionPath:boolean= false):string
  {      
      var paths = Array();      
      
      paths["Meeting"] = "meeting";
      paths["MeetingType"] = "meetingtype";
      paths["Association"] = "association";
      paths["SectionTemplate"] = "section_template";
      /*
      paths["Therapist"] = "therapist";
      paths["Client"] = "client";
      paths["Clientcase"] = "clientcase";
      paths["ClientCaseSession"] = "clientCaseSession";
      paths["UserAccess"]="useraccess";            
      */
     
      paths["DBUser"] = "user";      
      paths["User"] = "user";   
      
      paths['FillValue']="fillvalue"
      var name=c['apiName'];      
      return "/api/" + paths[name] + (collectionPath?"s":"");      
  }

  public list<T extends iRecordType>(c: new(values: Object)=> T, filter: Object,page:number=1,
    maxPerPage:number=30, sortBy:string="", sortDir:string="asc")
  {
    //var url:string  = API_URL + this.__apath(c, true) + "?XDEBUG_SESSION_START=netbeans-xdebug&page=" + page +"&items_per_page="+maxPerPage;
    var url:string  = API_URL + this.__apath(c, true) + "?page=" + page +"&items_per_page="+maxPerPage;

    if(sortBy!==null && sortBy.length>0)
    {
       if(sortDir==null) sortDir="asc";
       url += "&sort_by="+encodeURIComponent(sortBy)+"&sort_dir="+sortDir
    }
    
    if(filter !=undefined && filter!=null)
    {       
       url += "&filter=" + encodeURIComponent(JSON.stringify(filter));
    }

    return this.http
    .get(url,   
      {
        //headers: new HttpHeaders().set('Authorization','Bearer '+localStorage.getItem('_token'))
      });
  }  
  public listFillValueType()
  {
    var url:string = RES_URL + "/fill_values.json";
    return this.http
    .get(url,   
      {
        //headers: new HttpHeaders().set('Authorization','Bearer '+localStorage.getItem('_token'))
      });
  }

  public listFillValuesFor(value_type:number):Observable<Object>
  {
      return this.list(FillValue,{
        "value_type":{"op":"EQ","value1":value_type,value2:null}
      },1,10000,"item_label","asc");
  }

  public listCountries()
  {
    var url:string = RES_URL + "/countries.json";
    return this.http
    .get(url,   
      {
        //headers: new HttpHeaders().set('Authorization','Bearer '+localStorage.getItem('_token'))
      });
  }

  public checkUniqueEmail(email:string, skipId:string=null)
  {
    var url = API_URL + this.__apath(DBUser,false) +"/email_exists/" + encodeURIComponent(email);
    
    if(skipId!=null)
    {
      url += "&skipid="+skipId;
    }

    return this.http
    .get(url,   
      {
        //headers: new HttpHeaders().set('Authorization','Bearer '+localStorage.getItem('_token'))
      });
  }

  public changePassword(data:any)
  {
    var url = API_URL + this.__apath(DBUser,false) +"/change_pwd";    
    
    return this.http
    .put(url,data,   
      {
        //headers: new HttpHeaders().set('Authorization','Bearer '+localStorage.getItem('_token'))
      });

  }

  public resetPasswordRequest(email:string)
  {
      var url = API_URL + this.__apath(DBUser,false) +"/send_reset_email";    
      return this.http
      .put(url, {'username':email});
  }

  public resetPasswordSubmit(token:string, data:any)
  {
    var url = API_URL + this.__apath(DBUser,false) +"/reset/"+encodeURIComponent(token)+'';    
    return this.http
    .put(url,data);
  }

  public listByUrl<T extends iRecordType>(c: new(values: Object)=> T, url: string)
  {
    return this.http
    .get(API_URL + url)
    .map(response => {            
      return new c(response);
    })
    .catch(this.handleError);  
  }

  public read<T extends iRecordType>(c: new(values: Object)=> T, id: string): Observable<Object>
  {
    return this.http
    .get(API_URL + this.__apath(c) +"/" + id,{
      //headers: new HttpHeaders().set('Authorization','Bearer '+localStorage.getItem('_token'))
    });    
  }

  public customGet<T extends iRecordType>(c: new(values: Object)=> T, url, params:any, isCollectionUrl:boolean=false):Observable<Object>
  {
    return this.http
      .get(API_URL+ this.__apath(c,isCollectionUrl)+"/" + url, { params: params} );
  }

  public create<T>(c: new(values: Object)=> T, value: any, querystring:string="")
  {
    return this.http
    .post(API_URL + this.__apath(c) + (querystring.length>0?'?'+querystring:''), value,
    {
      //headers: new HttpHeaders().set('Authorization','Bearer '+localStorage.getItem('_token'))
    });    
  }

  public update<T extends iRecordType>(c: new(values: Object)=> T, value: T, id:string) 
  {
    return this.http
    .put(API_URL + this.__apath(c) + "/" + id , value,{
      //headers: new HttpHeaders().set('Authorization','Bearer '+localStorage.getItem('_token'))
    });
  }

  public delete<T extends iRecordType>(c: new(values: Object)=> T,id: string)
  {
    return this.http
    .delete(API_URL + this.__apath(c) + "/" + id,{
      //headers: new HttpHeaders().set('Authorization','Bearer '+localStorage.getItem('_token'))
    });    
  }

  public patch<T extends iRecordType>(c: new(values: Object)=> T, id: string, value: T)
  {
    return this.http
    .patch(API_URL + this.__apath(c) + "/" + id, value,{
      //headers: new HttpHeaders().set('Authorization','Bearer '+localStorage.getItem('_token'))
    });
  }


  

  public dashboard()
  {
    return this.http.get(API_URL+'/api/dashboard',{
     // headers: new HttpHeaders().set('Authorization','Bearer '+localStorage.getItem('_token'))
    });
  }

  public login(username: string, password: string): Observable<loginResult>
  {
        
    const body = new HttpParams()
    .set('_username', username)
    .set('_password', password);

    return this.http.post<loginResult>(API_URL + '/api/login_check??XDEBUG_SESSION_START=netbeans-xdebug',body.toString(),
  {
    headers: new HttpHeaders().set('Content-Type','application/x-www-form-urlencoded')
  });
    
    /*    
    .map(response=>{                
        let result:loginResult;
        result = new loginResult(response['data']);
        this._token= result.token;
        return result;
    })
    .catch(this.handleLoginError);    
    
    this.http.post<loginResult>(API_URL + '/login_check',
          {
            "_username": username,
            "_password": password
          }
      )*/

  }

public refreshToken(token:string)
{
  const body = new HttpParams()
      .set('refresh_token', token)
  return this.http.post<loginResult>(API_URL+'/api/token/refresh',body.toString(),
  {
    headers: new HttpHeaders().set('Content-Type','application/x-www-form-urlencoded')
  });
}

  private handleLoginError(error: Response|any)
  {    
    console.error('ApiService:Login Error', error);
    return Observable.throw(error);
  }

  private handleError(error: Response|any)
  {
    console.error('ApiService:Login Error', error);
    return Observable.throw(error);
  }
}



// WEBPACK FOOTER //
// I:/Yog/Projects/Web/LetterDev/wwwroot/ManagerApp/wwwroot/src/app/api/api.service.ts